module.exports = __webpack_public_path__ + "img/london.c44d875.jpg";